import * as React from 'react';

import { Modal, TTab, Tabs } from '@cian/ui-kit';
import { EGeoType } from 'shared/selectors/filters/geo/selectGeoTypeFilter';
import { SearchButtonContainer } from '../GeoSuggestContainer/containers/SearchButtonContainer';
import { useAppDispatch, useJsonQueryBackup } from 'shared/hooks';
import { applyFilters } from 'shared/thunks/filters';
import { updateTags } from 'shared/thunks/tags';
import { RegionalDistrictsModalContainerV2 } from '../GeoSuggestContainer/containers/RegionalDistricts/ModalContainerV2';
import { UndergroundMapModalContainerV2 } from '../GeoSuggestContainer/containers/UndergroundContainer/MapModalContainerV2';
import { DirectionsModalContainerV2 } from '../GeoSuggestContainer/containers/DirectionsContainer/ModalContainerV2';
import { DistrictsModalContainerV2 } from '../GeoSuggestContainer/containers/DistrictsContainer/ModalContainerV2';
import { selectPageType } from 'shared/selectors/page/selectPageType';
import { useSelector } from 'react-redux';
import { EPageType } from 'shared/types/page';
import { GeoSuggestLayout } from 'shared/components/GeoSuggestV2';

interface IGeoSuggestModalContainerType {
  tabItems: (TTab & { id: EGeoType })[];
  onModalClose: VoidFunction;
  geoSuggestNode: React.ReactNode;
}

export const GEO_SUGGEST_OPTIONS = {
  [EGeoType.Underground]: <UndergroundMapModalContainerV2 />,
  [EGeoType.RegionalDistricts]: <RegionalDistrictsModalContainerV2 />,
  [EGeoType.District]: <DistrictsModalContainerV2 />,
  [EGeoType.Highway]: <DirectionsModalContainerV2 />,
  [EGeoType.Address]: undefined,
};

export const GeoSuggestModalContainer: React.FC<IGeoSuggestModalContainerType> = ({
  tabItems,
  onModalClose,
  geoSuggestNode,
}) => {
  const dispatch = useAppDispatch();

  const { resetJsonQuery } = useJsonQueryBackup();
  const pageType = useSelector(selectPageType);

  const [activeTabIndex, setActiveTabIndex] = React.useState(0);

  const handleTabClick = (index: number): void => {
    setActiveTabIndex(index);
  };

  const handleClose = React.useCallback(() => {
    onModalClose();
    resetJsonQuery();
  }, [onModalClose, resetJsonQuery]);

  const handleApply = React.useCallback(async () => {
    onModalClose();
    dispatch(applyFilters());
    dispatch(updateTags(true));
  }, [dispatch, onModalClose]);

  const header = React.useMemo(() => {
    if (pageType === EPageType.SEARCH) {
      return (
        <GeoSuggestLayout>
          {geoSuggestNode}
          <Tabs onTabClick={handleTabClick} activeTabIndex={activeTabIndex} items={tabItems} size="S" />
        </GeoSuggestLayout>
      );
    }

    return <Tabs onTabClick={handleTabClick} activeTabIndex={activeTabIndex} items={tabItems} size="S" />;
  }, [activeTabIndex, geoSuggestNode, pageType, tabItems]);

  return (
    <Modal
      size="L"
      open
      onOpenChange={handleClose}
      header={header}
      body={GEO_SUGGEST_OPTIONS[tabItems[activeTabIndex].id]}
      footer={<SearchButtonContainer onClick={handleApply} />}
    />
  );
};
